import { toRefs, ref,onMounted,reactive, computed } from 'vue';
import moment from 'moment-timezone'

export function useUtil() {
    function convert2Base64(url, callback) {
        let xhr = new XMLHttpRequest();
        xhr.onload = function() {
            var reader = new FileReader();
            reader.onloadend = function() {
                callback(reader.result);
            }
            reader.readAsDataURL(xhr.response);
        };
        xhr.open('GET', url);
        xhr.responseType = 'blob';
        xhr.send();
    }
    function formatCurrency(amt){
        return amt!==undefined?amt.toLocaleString('zh-TW', { style: 'currency',  currency: 'TWD',minimumFractionDigits: 0,maximumFractionDigits: 0 }):'N/A'
    }
    function nest2Flat(target,key_string) {
        if(key_string == null || key_string == undefined ||  Object.keys(target).length==0){
            return ''
        }
        const keys = key_string.split(".")
        let result = {...target}

        for(let i in keys){
            if(result == undefined){
                break
            }
            result = result[keys[i]]
        }
        return result 
      }

    function scrollTo($el){
        $el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function formatDataTableExport(data, fields) {
        
        let targetFields = fields.filter(x => x.type == 'date' || x.type == 'boolean')
        let output = data.map((x)=>{
            let newItem = JSON.parse(JSON.stringify(x))
            targetFields.forEach(col => {

                //處理日期
                if(col.type == 'date'){
                    let flatVaule = nest2Flat(newItem,col.field)
                    let format  = "YYYY-MM-DD HH:mm" //col.format
                    let date = flatVaule?moment(flatVaule).format(format):''
                    newItem[col.field] = date
                }
                //處理資料顯示轉換
                else if(col.type == 'boolean'){
                    if(col.format){
                        newItem[col.field] = newItem[col.field]?col.format.t:col.format.f
                    }else{
                        newItem[col.field] = newItem[col.field]?'是':'否'

                    }
                }
                
            });
           
            return newItem
        })
        
        return output
    }
    function verifyIdentityNo(id) {
        id = id.trim();
       
        // <!-- 在 js 中遇到反斜線要跳脫，所以這邊用兩個反斜線 -->
        // 第二個字元接受 1、2、8 、 9 台灣1,2 居留證8,9
        let verification = id.match("^[A-Z][1289ABCD]\\d{8}$")
        if(!verification){
            return false
        }
    
        let conver = "ABCDEFGHJKLMNPQRSTUVXYWZIO"
        let weights = [1, 9, 8, 7, 6, 5, 4, 3, 2, 1, 1]
    
        // 新版規則
        let id_new = String(conver.indexOf(id[0]) + 10) + id.slice(1);
       
        let checkSum = 0
        for (let i = 0; i < id_new.length; i++) {
            let c = parseInt(id_new[i])
            let w = weights[i]
            checkSum += c * w
        }
        let new_rule = checkSum % 10 == 0

         // 舊版規則
        let id_old = String(conver.indexOf(id[0]) + 10) +  String((conver.indexOf(id[1]) + 10)%10) + id.slice(2);
        let checkSum2 = 0
        for (let i = 0; i < id_old.length; i++) {
            let c = parseInt(id_old[i])
            let w = weights[i]
            checkSum2 += c * w
        }
        let old_rule = checkSum2 % 10 == 0
        return new_rule || old_rule
    }
    async function convertPNGImage(file) {
        const readFile = (file)=> {
            return new Promise((resolve, reject) => {
              const reader = new FileReader();
      
              reader.onload = (e) => resolve(e.target.result);
              reader.onerror = reject;
      
              reader.readAsDataURL(file);
            });
        }
        const convertToJPEG = (imageSrc)=> {
            return new Promise((resolve, reject) => {
              const img = new Image();
              img.src = imageSrc;
      
              img.onload = () => {
                // 创建画布
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
      
                // 设置画布尺寸为图片尺寸
                canvas.width = img.width;
                canvas.height = img.height;
      
                // 填充白色背景
                ctx.fillStyle = 'white';  // 设置背景颜色为白色
                ctx.fillRect(0, 0, canvas.width, canvas.height);  // 填充整个canvas
      
                // 绘制图片到画布
                ctx.drawImage(img, 0, 0);
      
                // 将canvas中的内容转换为JPEG格式的Blob对象
                canvas.toBlob((blob) => {
                  if (blob) {
                    resolve(blob);
                  } else {
                    reject('Failed to convert to Blob');
                  }
                }, 'image/jpeg', 1.0); // 1.0是最高质量
              };
      
              img.onerror = reject;
            });
          }
        // 等待文件读取完成
        const imageSrc = await readFile(file);
        // 等待图片加载和转换
        const jpegBlob = await convertToJPEG(imageSrc);
        return jpegBlob
    }

    function externalBrowserUrl(url){
        if(url.indexOf('openExternalBrowser')>=0){
            return url
        }else if(url.indexOf('?')>=0){
            return `${url}&openExternalBrowser=1`

        }else{
            return `${url}?openExternalBrowser=1`

        }
    }
    return {convert2Base64,formatCurrency ,nest2Flat,scrollTo,formatDataTableExport,verifyIdentityNo,convertPNGImage,externalBrowserUrl};
}
